import { BaseAjaxForm } from "mixs/base/form_ajax_mixin";
import { VALID_USER }   from "apps/action_types";
import { validations }  from "apps/actions/validations";
import { save }         from "apps/actions/common";
import serializeJSON     from 'utilities/serialize_json';
class FormReply extends BaseAjaxForm {
  validFunction = validations.comment;
  submitFunction = save;
}
riot.mixin('forms.comments.reply', FormReply as riot.TagMixin)
